<mat-expansion-panel class="custom-step" expanded="true" hideToggle disabled>
  <div class="custom-step__content">
    @for (item of config; track item; let i = $index) {
      @if (i !== 0 && !item.hidden) {
        <div
          class="custom-step__spacer"
          [ngClass]="{ active: indexActive >= i }"
        ></div>
      }
      @if (!item.hidden) {
        <div
          class="custom-step__step"
        [ngClass]="{
          active: activeStep === item.id,
          disabled: indexActive < i,
          'dont-click': item.disable
        }"
          (click)="onChange(item.id)"
          >
          <div
            class="custom-step__step-icon"
            [ngClass]="{ active: activeStep === item.id }"
            >
            <div>{{ i + 1 }}</div>
          </div>
          <h3>{{ item.label }}</h3>
          @if (
            (item.id == indexActive && item.action && item.id != 0) ||
            (!readonly && item.id == 0)
            ) {
            <button
              mat-icon-button
              (click)="item.action!.change()"
              [matTooltip]="item.tooltip"
              color="success"
              class="mat-elevation-z0"
              >
              <mat-icon>add_circle</mat-icon>
            </button>
          }
        </div>
      }
    }
  </div>
</mat-expansion-panel>
